import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useLink } from '../../hooks/useLink.js';
import { getAspectsAttributes } from '../../utils/dataAttributes.js';
import { style } from '../../utils/style.js';
export const LinkList = JSX(({ className = '', items }) => {
    const link = useLink();
    return (_jsx("ul", { className: style('flex flex-col gap-s w-full', className), children: items?.map(renderLinkListItem(link)) }));
});
const renderLinkListItem = (link) => ({ dataFooter, ...linkProps }, i) => {
    const { text, href, target, onClick } = link(linkProps);
    if (!text) {
        return null;
    }
    return (_jsx("li", { className: "list-none", children: _jsx("a", { className: "hover:text-primary-main font-light", role: "link", href: href, target: target || '_self', onClick: onClick, ...getAspectsAttributes(dataFooter), children: text ? text : null }) }, String(i)));
};
//# sourceMappingURL=LinkList.js.map